// PatternsDialog.js
import { useState, useEffect } from "react"
import { Typography } from '@mui/material'
import PatternsForm from './PatternsForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} setNewName Sets the new name of this object if the user modifies the name.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @returns UI for interactive swmm modeling.
 */
export default function PatternsDialog({ model, targetType, target, setNewName, setFullModel }) {
  const [submodel, setSubmodel] = useState()
  const [newTargetName, setNewTargetName] = useState(target)

  useEffect(()=>{
    setSubmodel({
      PATTERNS: JSON.parse(JSON.stringify(model.PATTERNS))
    })
  },[model])

  function handleChange(e) {
    setNewName(e.target.value)
    setNewTargetName(e.target.value)
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(model){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Pattern Name</label>
              <input style={{fontSize: '16px', background: 'rgb(50, 50, 50)', color: 'lightskyblue', border: 'none', textAlign: 'center'}} type="text" value={newTargetName} onChange={handleChange} />
            </div>
          </Typography>
          <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
            {
              targetType && 
              targetType in model && 
              target &&
              <PatternsForm model={submodel} setModel={setSubmodel} setFullModel={setFullModel} target={target} targetType={'PATTERNS'} />
    }
          </div>
          </>
        }
      </>
    )
  } else {
    return null
  }
}